import { ReportTheme } from '../../types';

/**
 * Get color for chart elements based on index and theme
 */
export const getChartColor = (index: number, theme: ReportTheme['theme']): string => {
  const colors = [
    theme === 'light' ? '#3b82f6' : '#8884d8', // Blue
    '#82ca9d', // Green
    '#ffc658', // Orange
    '#ff7300', // Red
    '#00ff00', // Lime
    '#ff00ff', // Magenta
    '#00ffff', // Cyan
    '#ffff00', // Yellow
  ];
  
  return colors[index % colors.length];
};

/**
 * Get stroke and fill colors for area charts
 */
export const getAreaChartColors = (index: number, theme: ReportTheme['theme']) => {
  const color = getChartColor(index, theme);
  return {
    stroke: color,
    fill: color,
    fillOpacity: 0.3
  };
};

/**
 * Format data point names for display
 */
export const formatDataPointName = (point: string): string => {
  return point.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
};

/**
 * Check if widget has multiple data points
 */
export const hasMultipleDataPoints = (widget: any): boolean => {
  return widget.data_points && widget.data_points.length > 1;
};
